export default "__VITE_ASSET__Dez3RSk___"